module.exports = __webpack_public_path__ + "img/40.8292de4e.jpg";